import { render, staticRenderFns } from "./NewsArchive.vue?vue&type=template&id=275b6b3d&scoped=true&"
import script from "./NewsArchive.vue?vue&type=script&lang=js&"
export * from "./NewsArchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275b6b3d",
  null
  
)

export default component.exports